import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { PageLayout } from "@/components/VocationalTest/PageLayout"

export default function AdvancedInstructionsPage() {
  return (
    <PageLayout>
      <Card className="p-8 md:p-12 bg-card">
        <div className="space-y-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground">
            Dica importante antes de iniciar:
          </h2>

          <div className="space-y-6 text-lg">
            <p className="text-muted-foreground flex items-center justify-center gap-2">
              <span className="text-2xl">⌘</span>
              <span>Respire profundamente. Conte até 25Segundos.</span>
            </p>

            <div className="space-y-3 text-left max-w-xl mx-auto">
              <p className="text-foreground">
                ➟ Responda com sinceridade.
              </p>
              <p className="text-foreground">
                ➟ Não tente escolher o que "parece melhor" — escolha o que parece mais você.
              </p>
            </div>

            <p className="text-accent font-semibold text-xl mt-8">
              ✼ Quanto mais verdadeiro você for agora, mais preciso será o resultado.
            </p>
          </div>

          <Button
            onClick={() => router.visit("/advanced-questions")}
            size="lg"
            className="bg-gradient-primary hover:opacity-90 transition-opacity text-lg px-12 py-6 h-auto shadow-elegant hover-scale mt-8"
          >
            ➟ Estou Pronto(a)
          </Button>
        </div>
      </Card>
    </PageLayout>
  )
}
